<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="card col-md-6 mx-auto" id="challenge-content-text">
                        <lottie :options="defaultOptions" :height="100" :width="100" v-on:animCreated="handleAnimation"/>
                        <br>
                        <div class="thanks"> Thanks for your submission 🙏</div>
                        <div class="timeline">
                            <img src="../assets/application_challenge_submitted.svg" />
                        </div>
                        <RegularButton ctaText="View Profile" @pressed="buttonPressed"></RegularButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import lottie from 'vue-lottie'
import * as animationData from '../assets/animations/1127-success.json'
import NavBarLight from '@/components/NavBarLight'
import { setTimeout } from 'timers';
import RegularButton from '@/components/RegularButton'

export default {
    name: 'Submitted',
    components: {
        lottie,
        NavBarLight,
        RegularButton
    },
    data() {
        return {
            defaultOptions: {
                animationData: animationData.default,
                loop: false,
                autoplay: true
            },
            animationSpeed: 1
        }
    },
    methods: {
        handleAnimation: function(anim) {
            this.anim = anim;
        },

        buttonPressed: function() {
            console.log("our little button was pressed, yay!");
            this.$router.push("/profile");
        }
    }
}
</script>


<style scoped>

    .card {
		margin-top:20px; 
		margin-bottom:80px; 
        padding-top:20px;
		padding-bottom:20px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
	}

    .thanks {
        font-size: 1.1em;
    }

    .content-start {
        margin-top:58px;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:0%;
        margin-right:0%;
        padding-right:0%;
    }

    #challenge-content-text {
        padding-right:0%;
    }

    .timeline {
        margin-top:40px;
        margin-bottom:20px;
    }

</style>